import { render } from "./bookmark.vue?vue&type=template&id=5157d344&scoped=true"
import script from "./bookmark.vue?vue&type=script&lang=js"
export * from "./bookmark.vue?vue&type=script&lang=js"

import "./bookmark.vue?vue&type=style&index=0&id=5157d344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5157d344"]])

export default __exports__